import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "section is-large my-3" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { "data-testid": "result-title-text" }
const _hoisted_4 = { class: "row mt-3 quick-overview" }
const _hoisted_5 = { class: "col-xs-12 col-md-3 text-right" }
const _hoisted_6 = { class: "product-badge hidden-md mb-2" }
const _hoisted_7 = { class: "inner-badge" }
const _hoisted_8 = { class: "percent" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "bigtext" }
const _hoisted_11 = { class: "smalltext" }
const _hoisted_12 = { class: "col-xs-12 col-md-9" }
const _hoisted_13 = { class: "table" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-primary" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_21 = { class: "text-end bg-primary text-white bold" }
const _hoisted_22 = { class: "text-primary" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "text-primary" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_27 = { class: "text-end text-primary bold" }
const _hoisted_28 = { class: "text-primary" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_30 = { class: "text-end text-primary" }
const _hoisted_31 = { style: {"text-transform":"uppercase"} }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { class: "col-xs-12" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "pull-right" }, null, -1 /* HOISTED */)
const _hoisted_36 = { class: "responsive-table" }
const _hoisted_37 = { class: "table" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = { class: "text-end bold" }
const _hoisted_41 = { class: "field text-end bold" }
const _hoisted_42 = { class: "text-end positive-number" }
const _hoisted_43 = { class: "field text-end positive-number" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_45 = { class: "field text-end positive-number" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_47 = { class: "field text-end negative-number" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_49 = { class: "field text-end positive-number" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_51 = { class: "field text-end negative-number" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_53 = { class: "field text-end" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_55 = { class: "field text-end" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_57 = { class: "field text-end" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_59 = { class: "field text-end" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_61 = { class: "field text-end" }
const _hoisted_62 = { class: "break" }
const _hoisted_63 = { class: "text-end" }
const _hoisted_64 = { class: "field text-end" }
const _hoisted_65 = { class: "text-end negative-number" }
const _hoisted_66 = { class: "field text-end negative-number" }
const _hoisted_67 = { class: "text-end negative-number" }
const _hoisted_68 = { class: "field text-end negative-number" }
const _hoisted_69 = { class: "text-end negative-number" }
const _hoisted_70 = { class: "field text-end negative-number" }
const _hoisted_71 = { class: "text-end negative-number" }
const _hoisted_72 = { class: "field text-end negative-number" }
const _hoisted_73 = { class: "text-end negative-number" }
const _hoisted_74 = { class: "field text-end negative-number" }
const _hoisted_75 = { class: "text-end negative-number" }
const _hoisted_76 = { class: "field text-end negative-number" }
const _hoisted_77 = { class: "text-end negative-number" }
const _hoisted_78 = { class: "field text-end negative-number" }
const _hoisted_79 = { class: "break" }
const _hoisted_80 = { class: "text-end" }
const _hoisted_81 = { class: "field text-end" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_83 = { class: "field text-end negative-number" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "text-end negative-number" }
const _hoisted_86 = { class: "field text-end negative-number" }
const _hoisted_87 = {
  key: 1,
  class: "break-grey"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_89 = { class: "field text-end negative-number" }
const _hoisted_90 = { class: "bold" }
const _hoisted_91 = { class: "text-end" }
const _hoisted_92 = { class: "field text-end" }
const _hoisted_93 = { class: "bold" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_95 = { class: "field text-end" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "pull-right" }, null, -1 /* HOISTED */)
const _hoisted_97 = { class: "responsive-table" }
const _hoisted_98 = { class: "table compare-purchase" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_100 = { class: "field text-end bold" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_103 = { class: "field text-end bold" }
const _hoisted_104 = { class: "text-end" }
const _hoisted_105 = { class: "field text-end" }
const _hoisted_106 = { class: "text-end" }
const _hoisted_107 = { class: "field text-end" }
const _hoisted_108 = { class: "break-grey" }
const _hoisted_109 = { class: "text-end" }
const _hoisted_110 = { class: "field text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("message.result.special.festo.FestoLeasingrechner")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatToPercent(_ctx.resultData.savings.percentageSavings)), 1 /* TEXT */)
              ]),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("message.productBadgeBigText")), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("message.productBadgeSmallText")), 1 /* TEXT */)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.result.special.festo.MonatlicheLeasingrate")), 1 /* TEXT */),
              _hoisted_14,
              _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.monthlyLeasingRate)), 1 /* TEXT */)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.quickOverviewTd2")), 1 /* TEXT */),
              _hoisted_16,
              _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.calculateLeasingTotalValue(_ctx.resultData)), 1 /* TEXT */)
            ]),
            (_ctx.formData.typeOfWork === _ctx.TYPE_OF_WORK.NON_COLLECTIVE_EMPLOYEE)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", _hoisted_19, _toDisplayString(_ctx.$t("message.quickOverviewTd3")), 1 /* TEXT */)
                  ]),
                  _hoisted_20,
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.salaryConversion)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", _hoisted_22, _toDisplayString(_ctx.$t("message.result.special.festo.ZuschussFestoEur")), 1 /* TEXT */)
              ]),
              _hoisted_23,
              _createElementVNode("td", {
                class: _normalizeClass(["text-end", [_ctx.formData.typeOfWork === _ctx.TYPE_OF_WORK.NON_COLLECTIVE_EMPLOYEE ? 'bg-primary text-white bold' : 'text-primary bold']])
              }, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.leasingRate)), 3 /* TEXT, CLASS */)
            ]),
            (_ctx.formData.typeOfWork === _ctx.TYPE_OF_WORK.COLLECTIVE_EMPLOYEE)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", _hoisted_25, _toDisplayString(_ctx.$t("message.result.special.festo.EinsetzbareZulage")), 1 /* TEXT */)
                  ]),
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.bonusUsage.used)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", _hoisted_28, _toDisplayString(_ctx.$t("message.quickOverviewTd4")), 1 /* TEXT */)
              ]),
              _hoisted_29,
              _createElementVNode("td", _hoisted_30, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.netCharge)), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", _hoisted_31, _toDisplayString(_ctx.$t("message.productBadgeBigText")), 1 /* TEXT */)
              ]),
              _createElementVNode("td", _hoisted_32, [
                _createElementVNode("strong", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatToPercent(_ctx.resultData.savings.percentageSavings)), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("td", _hoisted_33, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.savings.totalSavings)), 1 /* TEXT */)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("strong", {
            class: _normalizeClass(["accordion-head collapsed d-flex", { active: _ctx.leasingTableActive }]),
            role: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leasingTableActive = !_ctx.leasingTableActive))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("message.result.special.festo.KostenFesto")), 1 /* TEXT */),
            _hoisted_35
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["accordion-body", { active: _ctx.leasingTableActive }])
          }, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("table", _hoisted_37, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("message.result.special.festo.GrundlageSteuerberechnung")), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t("message.tableHead2")), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$t("message.tableHead3")), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.monthlyIncome')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.formatToEuro(_ctx.formData.monthlyIncome)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatToEuro(_ctx.formData.monthlyIncome)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.result.special.festo.MonatlicheFestoLeistungszulage")), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.formatToEuro(_ctx.formData.bonus)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatToEuro(_ctx.formData.bonus)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.result.special.festo.ZuschussFestoEur")), 1 /* TEXT */),
                  _hoisted_44,
                  _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.leasingRate)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.result.special.festo.BarlohnumwandlungLeasingrate")), 1 /* TEXT */),
                  _hoisted_46,
                  _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.monthlyLeasingRate)), 1 /* TEXT */)
                ]),
                _createCommentVNode("                  <tr v-if=\"resultData.monthlyCosts.employerCosts.agavCosts\">"),
                _createCommentVNode("                    <td>"),
                _createCommentVNode("                      {{ $t('message.agavBonusIncludedInLeasingRate') }}"),
                _createCommentVNode("                    </td>"),
                _createCommentVNode("                    <td class=\"text-end\" />"),
                _createCommentVNode("                    <td"),
                _createCommentVNode("                      class=\"field text-end\""),
                _createCommentVNode("                    >"),
                _createCommentVNode("                      ({{formatToEuro(resultData.monthlyCosts.employerCosts.agavCosts)}})"),
                _createCommentVNode("                    </td>"),
                _createCommentVNode("                  </tr>"),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedGeldwerterVorteil')), 1 /* TEXT */),
                  _hoisted_48,
                  _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.geldwerterVorteil)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployeeInsurancePremium')), 1 /* TEXT */),
                  _hoisted_50,
                  _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.insuranceComfort)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployeeInsurancePremiumPlus')), 1 /* TEXT */),
                  _hoisted_52,
                  _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.insuranceWearAndTear, true)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployeeInsuranceInspection')), 1 /* TEXT */),
                  _hoisted_54,
                  _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.inspection, true)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployerInsurancePremium')), 1 /* TEXT */),
                  _hoisted_56,
                  _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.insuranceComfort, true)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployerInsurancePremiumPlus')), 1 /* TEXT */),
                  _hoisted_58,
                  _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.insuranceWearAndTear)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployerInsuranceInspection')), 1 /* TEXT */),
                  _hoisted_60,
                  _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.inspection)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_62, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedVersteuerbaresEinkommen')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.formatToEuro(_ctx.formData.monthlyIncome + _ctx.formData.bonus)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.taxableIncome)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedLohnsteuer')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.incomeTaxAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.incomeTaxAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedSolidaritaetszuschlag')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.solidarityContribution)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.solidarityContribution)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedKirchensteuer')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.churchTaxAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.churchTaxAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedKrankenversicherung')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.healthInsuranceAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.healthInsuranceAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedPflegeversicherung')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.healthCareInsuranceAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.healthCareInsuranceAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedRentenversicherung')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.pensionInsuranceAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_76, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.pensionInsuranceAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedAeitslosenversicherung')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.unemploymentInsuranceAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.unemploymentInsuranceAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_79, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.comparisonNetIncome')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_80, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.netIncome)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_81, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.netIncome)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedGeldwerterVorteilAbzug')), 1 /* TEXT */),
                  _hoisted_82,
                  _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.geldwerterVorteil)), 1 /* TEXT */)
                ]),
                (_ctx.formData.healthcareType !== _ctx.HEALTHCARE_TYPE.PUBLIC)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_84, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.contributionToPrivateHealthCareInsurance')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.formatToEuro(_ctx.calculateInsuranceContribution(_ctx.resultData))), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_86, _toDisplayString(_ctx.formatToEuro(_ctx.calculateInsuranceContribution(_ctx.resultData))), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.formData.typeOfWork === _ctx.TYPE_OF_WORK.COLLECTIVE_EMPLOYEE)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_87, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.result.special.festo.zNettoabzug')), 1 /* TEXT */),
                      _hoisted_88,
                      _createElementVNode("td", _hoisted_89, _toDisplayString(_ctx.formatToEuro(_ctx.calculateAdditionalNetCosts(_ctx.resultData))), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("tr", _hoisted_90, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedAuszahlungsbetrag')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_91, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.payoutAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_92, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.payoutAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_93, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.quickOverviewTd4')), 1 /* TEXT */),
                  _hoisted_94,
                  _createElementVNode("td", _hoisted_95, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.netCharge)), 1 /* TEXT */)
                ])
              ])
            ])
          ], 2 /* CLASS */),
          _createElementVNode("strong", {
            class: _normalizeClass(["accordion-head collapsed d-flex", { active: _ctx.comparePurchaseTableActive }]),
            role: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.comparePurchaseTableActive = !_ctx.comparePurchaseTableActive))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("message.result.special.festo.VergleichEigenkauf")), 1 /* TEXT */),
            _hoisted_96
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["accordion-body", { active: _ctx.comparePurchaseTableActive }])
          }, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("table", _hoisted_98, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.totalsTotalLeasingRates')) + " ", 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formData.leasingTime) + " " + _toDisplayString(_ctx.$t('message.month')), 1 /* TEXT */),
                    _createCommentVNode("                      {{ $t(\"message.result.special.festo.nurNet\") }}")
                  ]),
                  _hoisted_99,
                  _createElementVNode("td", _hoisted_100, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.totalLeasingRates)), 1 /* TEXT */)
                ]),
                (_ctx.formData.typeOfWork===1)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_101, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.result.special.festo.VerwendeteFestoLeistungszulage")), 1 /* TEXT */),
                      _hoisted_102,
                      _createElementVNode("td", _hoisted_103, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.bonusUsage.total * _ctx.formData.leasingTime)), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.result.special.festo.durchMitarbeiter")), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.bikeCosts.bikePrice)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_105, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.bikeCosts.remainingBikeValue)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.totalsTotalCostOfLeasing')) + " ", 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formData.leasingTime) + " " + _toDisplayString(_ctx.$t('message.month')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_106, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.totalCostOfPurchase)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_107, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.totalCostOfLeasing)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_108, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.savingsAbsolute')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_109, _toDisplayString(_ctx.formatToPercent(_ctx.resultData.savings.percentageSavings)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_110, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.savings.totalSavings)), 1 /* TEXT */)
                ])
              ])
            ])
          ], 2 /* CLASS */)
        ])
      ])
    ])
  ]))
}